export class OidcSettings {
  public clientId: string;
  public issuer: string;
  public redirectUri: string;
  public scopes: string[];
  public pkce: boolean;
}
